// page.tsx
"use client";

import { useState, Suspense, lazy } from "react";
import LockScreen from "../../Components/Lockscreen";
import "./Activist.css";

import { ActivistMailContent } from "./ActivistAssets/ActivistMailContent";
import { influencerNoteContent } from "./ActivistAssets/ActivistNoteContent";
import { influencerMessageContent } from "./ActivistAssets/ActivistMessagesContent";
import { InfluencerCallContent } from "./ActivistAssets/ActivistCallContent";
import { Chat_content } from "../../Components/MessageApp/MessagesInterfaces";
import ActivistMap from "./ActivistAssets/ActivistMapContent/MMCActivist-Map.jpg";
import CallApp from "../../Components/CallApp/CallApp";
import { ActivistPhotoContent } from "./ActivistAssets/ActivistPhotoContent";
import InternetBanner from "./ActivistAssets/ActivistPictures/NJP News Logo.jpg";
import InternetArtical from "./ActivistAssets/ActivistPictures/NJP Article Photo.jpg";
import HomeIcon from "../../Components/Icons/HomeIcon";
import { ActivistMapContent } from "./ActivistAssets/ActivistMapContent/ActivistMapContent";

const Messages = lazy(() => import("../../Components/MessageApp/Messages"));
const Photos = lazy(() => import("../../Components/PhotosApp/Photos"));
const AppsMenuActivist = lazy(
  () => import("../../Components/AppsMenu/AppsMenuActivist")
);
const NotesApp = lazy(() => import("../../Components/NotesApp/NotesApp"));
const MapApp = lazy(() => import("../../Components/MapApp/MapsStatic"));
const InternetApp = lazy(
  () => import("../../Components/InternetApps/ActivistInternetApp/InternetApp")
);
const MailApp = lazy(() => import("../../Components/MailApp/MailApp"));

function Activist() {
  const [isLocked, setIsLocked] = useState(true);
  const [activeApp, setActiveApp] = useState("appsmenu");
  const [messages, setMessages] = useState(influencerMessageContent);
  const [messageNotifications, setMessageNotifications] = useState(0);

  const unlock = () => {
    setIsLocked(false);
  };

  const handleStateChange = (chat: Chat_content) => {
    const chatIndex = messages.findIndex(
      (message) => message.name === chat.name
    );
    const previousMessage = messages[chatIndex];
    if (previousMessage && !previousMessage.read) {
      const newMessages = [...messages];
      newMessages[chatIndex] = {
        ...newMessages[chatIndex],
        read: true,
      };
      setMessages(newMessages);
      setMessageNotifications(messageNotifications - 1);
    }
  };

  const renderApp = () => {
    switch (activeApp) {
      case "messages":
        return (
          <Messages
            influencerMessageContent={messages}
            theGram={false}
            handleStateChange={handleStateChange}
          />
        );
      case "phone":
        return <CallApp callContent={InfluencerCallContent} />;
      case "photos":
        return <Photos albums={ActivistPhotoContent} />;
      case "notes":
        return <NotesApp noteContent={influencerNoteContent} />;
      case "appsmenu":
        return (
          <AppsMenuActivist
            isLocked={isLocked}
            setActiveApp={setActiveApp}
            messageNotifications={messageNotifications}
          />
        );

      case "mail":
        return <MailApp emails={ActivistMailContent} />;
      case "maps":
        return (
          <MapApp mapImage={ActivistMap} recentSearches={ActivistMapContent} />
        );
      case "internet":
        return (
          <InternetApp
            headerImage={InternetBanner}
            bodyImage={InternetArtical}
            searchBarText="Astor family death"
            articleTitle="Four dead in tragic Astor family helicopter crash"
            articleDate="Thursday Jan 25, 2024"
            author="Written by Philip Marre"
            photoCaption="The Astor family’s private helicopter"
            bodyText="Alexander and Eleanor Astor, of the New Jersey Astor family, tragically died in a helicopter crash in the early hours of this morning, along with the pilot and copilot.
            
            Early reports suggest that the crash was caused by a technical fault. "
            website="www.newjerseypost.co"
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="Mystery">
      <div className="phone-wrapper">
        <div className={`Activistscreen ${activeApp}`}>
          {isLocked ? (
            <div
              className={`lockscreen-container ${
                isLocked ? "visible" : "hidden"
              }`}
            >
              <LockScreen unlock={unlock} password="911749" />
            </div>
          ) : null}

          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            }
          >
            {renderApp()}
          </Suspense>
          <div className="home-button-container">
            <HomeIcon onClick={() => setActiveApp("appsmenu")} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Activist;
